

export enum EProductType {
  anPostCombined = "an-post-combined",
  anPostDsu = "an-post-dsu",
  anPostMailCentre = "an-post-mail-centre",
  banking = "banking",
  brandHome = "brandHome",
  facilities = "facilities",
  failteIrelandAccommodation = "failte-ireland-accommodation",
  failteIrelandAttractions = "failte-ireland-attractions",
  failteIrelandRetail = "failte-ireland-retail",
  foodAndBeverage = "food-and-beverage",
  generic = "generic",
  manufacturing = "manufacturing",
  manufacturingCampus = "manufacturing-campus",
  postOffice = "post-office",
  publicRealm = "public-realm",
  retail = "retail",
}


